// extracted by mini-css-extract-plugin
module.exports = {"headerPanelPadding":"ComponentHeader-module--header-panel-padding--2f2QN"};